import { useTranslations } from 'next-intl'

type Props = {
  totalElements: number
  keyword?: string
}

export const MobileSearchResult = ({ totalElements, keyword = '' }: Props) => {
  const t = useTranslations('faq')

  return (
    <div className="px-4 py-6">
      <div className="typo-title3 flex items-center gap-2 font-bold text-black">
        {t('search_result.title')}
        <span className="typo-headline3 text-purple-500">{totalElements}</span>
      </div>
      <p className="typo-label1 mt-1 flex flex-wrap gap-1 text-gray-900">
        {t.rich('search_result.description', {
          keyword,
          highlight: chunks => (
            <span className="text-purple-500">{chunks}</span>
          ),
        })}
      </p>
    </div>
  )
}
